import React from 'react';

interface Step {
  name: string;
}

const steps: Step[] = [
  { name: 'Account Setup' },
  { name: 'Information' },
  { name: 'Connect Facebook page to Instagram' },
  { name: 'Give Facebook page Permissions' },
];

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const ProgressStepsMobile: React.FC<{ currentStep: number }> = ({ currentStep }) => {
  return (
    <nav aria-label="Progress" className="w-full">
      <ol className="relative flex items-center justify-center w-full">
        {/* Line Before Current Step */}
        {currentStep > 1 && (
          <div
            className="absolute left-0 right-[50%] top-[30%] -translate-y-1/2 h-1 bg-black z-0 transition-all duration-300"
            style={{
              width: `40%`, // Adjust width based on current step
            }}
          />
        )}

        {/* Line After Current Step */}
        {currentStep < steps.length && (
          <div
            className="absolute right-0 left-[50%] top-[30%] -translate-y-1/2 h-1 bg-blue-500 z-0 transition-all duration-300"
            style={{
              width: `40%`, // Adjust width based on remaining steps
            }}
          />
        )}

        {steps.map((step, stepIdx) => (
          <li
            key={step.name}
            className={`relative flex flex-col items-center z-10 ${
              stepIdx + 1 === currentStep ? 'visible' : 'hidden'
            }`}
          >
            {/* Circle with Step Number */}
            <div
              className={classNames(
                'flex items-center justify-center h-10 w-10 rounded-full transition-colors duration-300',
                stepIdx + 1 === currentStep
                  ? 'bg-blue-500 text-white' // Current step
                  : 'bg-gray-100 text-gray-500'
              )}
            >
              {stepIdx + 1}
            </div>

            {/* Step Name */}
            <span
              className="mt-2 text-sm font-medium text-center text-black"
            >
              {step.name}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default ProgressStepsMobile;
